import type { SVGProps } from 'react';

export function MeteorIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.914 2.434 13.63 5.235l.086-1.099a.602.602 0 0 0-.9-.566L6.2 7.403A7.61 7.61 0 0 0 2.4 13.988a7.613 7.613 0 0 0 7.613 7.612 7.61 7.61 0 0 0 6.585-3.799l3.832-6.615a.6.6 0 0 0-.566-.9l-1.099.087 2.801-7.283a.504.504 0 0 0-.652-.652zM9.6 9.6a4.8 4.8 0 1 1 0 9.6 4.8 4.8 0 0 1 0-9.6m0 3.6c0-.664-.536-1.2-1.2-1.2s-1.2.536-1.2 1.2.536 1.2 1.2 1.2 1.2-.536 1.2-1.2m.6 3.6c.33 0 .6-.27.6-.6s-.27-.6-.6-.6-.6.27-.6.6.27.6.6.6" />
    </svg>
  );
}
